import { useContext, useEffect, useState } from "react";
import { sendTagOnError } from "app/utils/analytics";
import AppGlobalsContext from "app/AppGlobalsContext";
import { COUNTRY_WITH_STATE_OR_PROVINCES } from "app/constants";

export const useStateAndProvinces = countryCode => {
	const [stateAndProvinces, setStateAndProvinces] = useState([]);

	const { shop } = useContext(AppGlobalsContext);
	const [locale] = shop.split("-");

	useEffect(() => {
		if (locale && COUNTRY_WITH_STATE_OR_PROVINCES.includes(countryCode)) {
			import(`./stateAndProvinces/${countryCode}/${locale}.json`)
				.then(module => {
					let finalStateAndProvinces = [...module.default].sort((a, b) =>
						a.name.localeCompare(b.name, locale)
					);

					setStateAndProvinces(finalStateAndProvinces);
				})
				.catch(error => {
					// eslint-disable-next-line no-console
					console.error(error);
					sendTagOnError(error);
				});
		}
	}, [locale, countryCode]);

	return stateAndProvinces;
};
